"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Antd = __importStar(require("antd"));
var form_calendar_svg_1 = __importDefault(require("./icons/form-calendar.svg"));
exports.DatePicker = styled_components_1.default(Antd.DatePicker).attrs(function () { return ({
    suffixIcon: react_1.default.createElement("img", { src: form_calendar_svg_1.default })
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    input {\n        padding: ", ";\n        height: initial;\n        font-size: ", ";\n    }\n"], ["\n    width: 100%;\n    input {\n        padding: ", ";\n        height: initial;\n        font-size: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xs + " " + theme.spacing.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.bodySmall.fontSize;
});
var templateObject_1;
//# sourceMappingURL=DatePicker.js.map